// //Samp lePage
import SamplePage from "../Components/Pages/PageLayout/SimplePage";
import CustomersTable from "../Components/Pages/Customers/CustomerTable";
import Contact from "../Components/Pages/Contact/ContactApp";
import Services from "../Components/Pages/Services";
import RolesTable from "../Components/Pages/Users/rolesTable";
import ProgramsTable from "../Components/Pages/Services/programsTable";
import ServicesTable from "../Components/Pages/Services/servicesTable";
import UsersTable from "../Components/Pages/Users/usersTable";
import Dashboard from "../Components/Pages/Dashboard/dashboard";
import TreeView from "../Components/Pages/Services/treeView";
import ServiceDetails from "../Components/Pages/Services/components/ServiceDetails/serviceDetails";
import ProgramDetails from "../Components/Pages/Services/components/ProgramDetails/programDetails";
import Tickets from "../Components/Pages/SupportTicket/index";
import TicketBoard from "../Components/Pages/KanbanTickets/index";
import TicketDetail from "../Components/Pages/KanbanTickets/TicketDetails";
import MemberBenefits from "../Components/Pages/MemberBenefits/Member-Benefits";
import SubServicesTable from "../Components/Pages/Services/subServicesTable";
import CategoriesTable from "../Components/Pages/Services/categoriesTable";
import Commercials from "../Components/Pages/commercials/commercials";
import Blogs from "../Components/Pages/Blogs/blogs";
import Analytics from "../Components/Pages/Analytics/analytics";
import ManageBccMailTable from "../Components/Pages/ManageBccMail/manageBccMailTable";
import ManageClientsTable from "../Components/Pages/ManageClients/manageClientsTable";
import MembershipPlansTable from "../Components/Pages/MembershipPlans/manageMembershipPlanTable.jsx";
import ManagePlans from "../Components/Pages/ManagePlans/managePlansTable";
import ProductsCollections from "../Components/Pages/Products/productsCollections";
import ManageVendors from "../Components/Pages/Vendors/manage-vendors";
import PermissionManagement from "../Components/Pages/Users/permission_mgmtTable";
import FormManagmentPage from "../Components/Pages/FormManagement";
import CreateFormBuilder from "../Components/Pages/FormManagement/_component/CreateFormBuilder";
import ViewForm from "../Components/Pages/FormManagement/_component/ViewForm";
import ServiceFormPlanMapping from "../Components/Pages/FormManagement/_component/ServiceFormPlanMapping";
import CreateFormMappingPage from "../Components/Pages/FormManagement/_component/CreateFormMappingPage";
import CommunicationConfigurationPage from "../Components/Pages/CommunicationConfiguration";

import SubCategoriesTable from "../Components/Pages/Services/subCategoriesTable";
import TenantConfiguration from "../Components/Pages/TenantConfiguration/tenantConfiguration.jsx";
import MemberBenefitsMapping from "../Components/Pages/MemberBenefitsMapping/MemberBenefitsMapping";
import CustomersTableMB from "../Components/Pages/Customers/CustomerTableMB.jsx";
import DirectCustomerUpload from "../Components/Pages/DirectCustomerUpload/directCustomerUpload.jsx";
import ManageProfile from "../Components/Pages/Users/ManageProfile.jsx";
import GetInTouch from "../Components/Pages/GetInTouch/index.jsx";
import Newsletter from "../Components/Pages/Newsletter/index.jsx";
import FailedCreditServices from "../Components/Pages/FailedCreditServices/index.jsx";
import ManageAddOnServicesTable from "../Components/Pages/ManageAddOnServices/manageAddOnServicesTable.jsx";
import ProvisioningPage from "../Components/Pages/Provisioning/ProvisioningPage.jsx";
import RenewalPage from "../Components/Pages/Renewal/RenewalPage.jsx";

export const routes = [
  // //page
  {
    path: `${process.env.PUBLIC_URL}/pages/failed-credit-services`,
    Component: <FailedCreditServices />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/get-in-touch`,
    Component: <GetInTouch />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/newsletter`,
    Component: <Newsletter />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/sample-page/:layout`,
    Component: <SamplePage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/customers`,
    Component: <CustomersTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/provisioning`,
    Component: <ProvisioningPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/renewal`,
    Component: <RenewalPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/contact-app/contacts`,
    Component: <Contact />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/service-grouping`,
    Component: <ServicesTable />,
  },
  { path: `${process.env.PUBLIC_URL}/pages/roles`, Component: <RolesTable /> },
  {
    path: `${process.env.PUBLIC_URL}/pages/programs`,
    Component: <ProgramsTable />,
  },
  { path: `${process.env.PUBLIC_URL}/pages/users`, Component: <UsersTable /> },
  {
    path: `${process.env.PUBLIC_URL}/pages/dashboard`,
    // Component: <Dashboard />,
    Component: <Analytics />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/tree-view`,
    Component: <TreeView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/service-details`,
    Component: <ServiceDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/program-details`,
    Component: <ProgramDetails />,
  },

  {
    path: `${process.env.PUBLIC_URL}/pages/tickets`,
    Component: <TicketBoard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/tickets-details`,
    Component: <TicketDetail />,
  },

  {
    path: `${process.env.PUBLIC_URL}/pages/member-benefits`,
    Component: <MemberBenefits />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/sub-services`,
    Component: <SubServicesTable />,
  },

  {
    path: `${process.env.PUBLIC_URL}/pages/service-categories`,
    Component: <CategoriesTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/commercials`,
    Component: <Commercials />,
  },

  {
    path: `${process.env.PUBLIC_URL}/pages/blogs`,
    Component: <Blogs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/analytics`,
    Component: <Analytics />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/manage-clients`,
    Component: <ManageClientsTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/manage-plans`,
    Component: <ManagePlans />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/manage-addon-services`,
    Component: <ManageAddOnServicesTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/membership-plans`,
    Component: <MembershipPlansTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/manage-bcc-mail`,
    Component: <ManageBccMailTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/manage-vendors`,
    Component: <ManageVendors />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/prodcuts-collections`,
    Component: <ProductsCollections />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/permission-management`,
    Component: <PermissionManagement />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management`,
    Component: <FormManagmentPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/create`,
    Component: <CreateFormBuilder />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/edit/:id`,
    Component: <CreateFormBuilder />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/view/:id`,
    Component: <ViewForm />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/mapping/:formId`,
    Component: <ServiceFormPlanMapping />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/mapping/:formId/create`,
    Component: <CreateFormMappingPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/mapping/:formId/edit/:mappingId`,
    Component: <CreateFormMappingPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/form-management/mapping/:formId/view/:mappingId`,
    Component: <CreateFormMappingPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/configuration`,
    Component: <CommunicationConfigurationPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/tenant-configuration`,
    Component: <TenantConfiguration />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/service-sub-categories`,
    Component: <SubCategoriesTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/member-benefits-mapping`,
    Component: <MemberBenefitsMapping />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/customers-member-benefit`,
    Component: <CustomersTableMB />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/direct-customer-upload`,
    Component: <DirectCustomerUpload />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/manage-profile`,
    Component: <ManageProfile />,
  },
];
